// Shared shape for "a vehicle or asset tracked by Make Ready", used by both
// the governance overview and the operative restock queue so the two views
// can't drift on what a tracked item looks like.
export const normalizeVehicle = (vehicle) => {
  const inventory = vehicle.inventory || {}
  const expiringSoonItems = inventory.expiringSoonItems || []
  return {
    id: vehicle._id,
    kind: 'vehicle',
    label: vehicle.callSign,
    subLabel: vehicle.vehicleType || '',
    loadListId: vehicle.makeReadyLoadList || null,
    lastCheckedAt: inventory.lastCheckedAt || null,
    missingItems: inventory.missingItems || [],
    expiredItems: inventory.expiredItems || [],
    expiringSoonItems,
    missingCount: (inventory.missingItems || []).length,
    expiredCount: (inventory.expiredItems || []).length,
    expiringSoonCount: expiringSoonItems.length,
    // Recorded stock the current load list no longer asks for - shown for
    // tidy-up only, never counted as expired (helpers/makeReady/loadListItems.js).
    offListItems: inventory.offListItems || [],
    offListCount: (inventory.offListItems || []).length,
    hasExpiredItems: !!inventory.hasExpiredItems,
    hasMissingItems: !!inventory.hasMissingItems,
  }
}

export const normalizeAsset = (asset) => {
  const inventory = asset.inventory || {}
  const expiringSoonItems = inventory.expiringSoonItems || []
  return {
    id: asset._id,
    kind: 'asset',
    label: asset.assetID,
    category: asset.category || 'Other',
    subLabel: [asset.category, asset.subCategory].filter(Boolean).join(' · '),
    loadListId: asset.makeReadyLoadList || null,
    lastCheckedAt: inventory.lastCheckedAt || null,
    missingItems: inventory.missingItems || [],
    expiredItems: inventory.expiredItems || [],
    expiringSoonItems,
    missingCount: (inventory.missingItems || []).length,
    expiredCount: (inventory.expiredItems || []).length,
    expiringSoonCount: expiringSoonItems.length,
    // Recorded stock the current load list no longer asks for - shown for
    // tidy-up only, never counted as expired (helpers/makeReady/loadListItems.js).
    offListItems: inventory.offListItems || [],
    offListCount: (inventory.offListItems || []).length,
    hasExpiredItems: !!inventory.hasExpiredItems,
    hasMissingItems: !!inventory.hasMissingItems,
  }
}
